import { UserContext } from "@/context/User/UserContext";
import { getDesignations } from "@/services/Designation.service";
import { Designation } from "@/types/designation.types";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import CreateDesignation from "../dialog/CreateDesignation";
import ColumnHeader from "../table/ColumnHeader";
import LawFirmTable from "../table/LawFirmTable";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Designations = () => {
	const user = useContext(UserContext);

	const designations = useQuery({
		queryKey: ["designations"],
		queryFn: () => getDesignations(user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<div>
					<h1 className="text-3xl font-bold">Designations</h1>
				</div>
				<CreateDesignation user={user} />
			</div>
			<div className="bg-white pb-4 border rounded-md shadow-sm">
				{designations.isLoading ? (
					<div className="grid gap-4 pt-4">
						{Array.from({ length: 10 }).map((_, num) => (
							<Skeleton key={num} className="h-12 w-full" />
						))}
					</div>
				) : designations.data ? (
					<LawFirmTable data={designations.data} columns={Columns} />
				) : (
					<p>No data</p>
				)}
			</div>
		</div>
	);
};

export default Designations;

const Columns: ColumnDef<Designation>[] = [
	{
		accessorKey: "designationid",
		header: ({ column }) => (
			<ColumnHeader column={column} title="Designation Id" />
		),
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/designation/${row.original.designationid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						{row.getValue("designationid")}
					</Button>
				</NavLink>
			</div>
		),
	},
	{
		accessorKey: "designation",
		header: ({ column }) => <ColumnHeader column={column} title="Designation" />,
	},
	{
		accessorKey: "actions",
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/designation/${row.original.designationid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						View
					</Button>
				</NavLink>
			</div>
		),
	},
];
